import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Solicitação', flex: 1.5, orderValue: 'requestDate' },
  { title: 'Tipo', flex: 1.5, orderValue: 'movementType' },
  { title: 'Cliente', flex: 1.5, orderValue: 'clientName' },
  { title: 'Emissor', flex: 1.5, orderValue: 'issuerName' },
  { title: 'Ativo', flex: 1, orderValue: 'productName' },
  { title: 'Taxa', flex: 1, orderValue: 'rateDescription' },
  { title: 'Vencimento', flex: 1, orderValue: 'maturityDate' },
  { title: 'Valor', flex: 1, orderValue: 'movementValue' },
  { title: 'Status', flex: 1, orderValue: 'status' },
];
